import CASL from '@/utils/constants/casl'

export default {
  path: 'po-management',
  children: [
    {
      path: '',
      name: 'po-management.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PURCHASE_ORDER
      },
      component: () => import('./list/PoManagementListPage.vue')
    },
    {
      path: 'add',
      name: 'po-management.add',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PURCHASE_ORDER
      },
      component: () => import('./form/PoManagementFormPage.vue')
    },
    {
      path: ':uid',
      name: 'po-management.edit',
      meta: {
        action: 'update',
        subject: CASL.ACCESS.PURCHASE_ORDER
      },
      component: () => import('./form/PoManagementFormPage.vue')
    }
  ]
}
